import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui-kit/button';

interface ErrorStateProps {
  image: string;
  title: string;
  description: string;
  buttonText?: string;
  buttonIcon?: ReactNode;
  buttonLink?: string;
  onButtonClick?: () => void;
}

export const CustomErrorView = ({
  image,
  title,
  description,
  buttonText,
  buttonIcon,
  buttonLink,
  onButtonClick,
}: Readonly<ErrorStateProps>) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else if (buttonLink) {
      navigate(buttonLink);
    }
  };

  return (
    <div className="flex justify-center items-center w-full px-4 py-6">
      <div className="flex flex-col items-center gap-12 max-w-full">
        <img src={image} alt="error state" className="h-auto w-full max-w-[480px]" />
        <div className="flex flex-col items-center text-center">
          <h1 className="text-foreground font-bold text-[32px] leading-[48px] [overflow-wrap:anywhere]">
            {title}
          </h1>
          <p className="mt-3 mb-6 text-muted-foreground font-semibold text-2xl [overflow-wrap:anywhere]">
            {description}
          </p>
          {buttonText && (
            <Button className="font-bold text-sm" onClick={handleButtonClick}>
              {buttonText}
              {buttonIcon}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
